import { Fragment, useEffect, useReducer } from 'react';
import { I18nHMRContext } from '../internal/i18n-internal';
import { jsx as _jsx } from "react/jsx-runtime";
const __I18nHMRProvider = ({
  children
}) => {
  const [rerenderCount, forceRerender] = useReducer(i => i + 1, 0);
  useEffect(() => {
    window.addEventListener('i18n_reload_complete', forceRerender);
    return () => {
      window.removeEventListener('i18n_reload_complete', forceRerender);
    };
  }, []);
  return /*#__PURE__*/_jsx(I18nHMRContext.Provider, {
    value: rerenderCount,
    children: children
  });
};
export const I18nHMRProvider =
// @ts-expect-error Module not defined
process.env.NODE_ENV === 'development' && module.hot ? __I18nHMRProvider : Fragment;